import { useState } from 'react';
import { useAtom } from 'jotai';

import { beauty_active_ingredient_item_idx_atom, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';
import { PopupViewType, usePopupView } from '@domains/pdp-common';

export type IngredientType = 'primary' | 'warning';

export const useBeautyService = () => {
  const { showPopup } = usePopupView();
  const params = useCatalogProductIdParams();
  const {
    product: { beauty_info },
  } = usePdpBaseInfo(params);

  // 성분 요약 + 탭 > 성분 그룹 아이템 활성화
  const [activeIngredientItem, setActiveIngredientItem] = useAtom(beauty_active_ingredient_item_idx_atom);
  const updateActiveIngredientItem = (type: IngredientType, idx: number) => {
    setActiveIngredientItem((prev) => ({ ...prev, [type]: idx }));
  };

  // 성분 정보 팝업
  const [ingredientInfoOpen, setIngredientInfoOpen] = useState(false);
  const handleIngredientInfoPopup = (isOpen: boolean) => {
    if (isOpen) {
      showPopup(PopupViewType.BEAUTY_INGREDIENT_INFO, () => {
        setIngredientInfoOpen(true);
      });
      return;
    }
    setIngredientInfoOpen(false);
  };

  // 성분 정보 유의사항 팝업
  const [ingredientNoticeOpen, setIngredientNoticeOpen] = useState(false);
  const handleIngredientNoticePopup = (isOpen: boolean) => {
    if (isOpen) {
      showPopup(PopupViewType.BEAUTY_INGREDIENT_NOTICE, () => {
        setIngredientNoticeOpen(true);
      });
      return;
    }
    setIngredientNoticeOpen(false);
  };

  return {
    oneLineReview: beauty_info?.beauty_one_line_review ?? null,
    ingredientSummary: beauty_info?.beauty_ingredient_summary ?? null,
    ingredientDetail: beauty_info?.beauty_ingredient_detail ?? null,
    activeIngredientItem,
    updateActiveIngredientItem,
    ingredientInfoOpen,
    handleIngredientInfoPopup,
    ingredientNoticeOpen,
    handleIngredientNoticePopup,
  };
};
